import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/SC50.png'
import _imports_1 from '../assets/images/SC80.png'
import _imports_2 from '../assets/images/battery_online3.png'
import _imports_3 from '../assets/images/water_online4.png'
import _imports_4 from '../assets/images/sewage_online4.png'


const _withScopeId = n => (_pushScopeId("data-v-9b06b2ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { style: {"margin-right":"20px"} }
const _hoisted_5 = {
  key: 0,
  style: {"width":"120px"},
  src: _imports_0
}
const _hoisted_6 = {
  key: 1,
  style: {"width":"150px","margin-top":"10px"},
  src: _imports_1
}
const _hoisted_7 = { style: {"margin-right":"50px"} }
const _hoisted_8 = { class: "vinTitle" }
const _hoisted_9 = { class: "cardGroup" }
const _hoisted_10 = { class: "cardItem" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "cardItem" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_14 = { class: "cardItem" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_16 = { style: {"width":"700px"} }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingPage = _resolveComponent("LoadingPage")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoadingPage, {
      isLoading: _ctx.isLoading,
      tip: _ctx.t('resetting')
    }, null, 8, ["isLoading", "tip"]),
    _createVNode(_component_a_breadcrumb, { class: "breadcrumb" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_breadcrumb_item, { class: "black" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("vehiclemanagement")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: `${_ctx.routerName.vehiclelist}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("vehiclelist")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, { class: "currentrouter" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("vehicleinformation")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.detail?.vehicle_type === 'SC50')
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.detail?.vehicle_type === 'SC80')
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.detail?.vin), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.t("vehiclestatus")) + "：" + _toDisplayString(_ctx.vehicleStatus(_ctx.detail?.vehicle_status, _ctx.t)), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", null, _toDisplayString(_ctx.t("electricitylevel")) + ":" + _toDisplayString(_ctx.detail?.electricity) + "%", 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("span", null, _toDisplayString(_ctx.t("cleanwatertank")) + ":" + _toDisplayString(_ctx.detail?.clean_water_rate) + "%", 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", null, _toDisplayString(_ctx.t("bilgetank")) + ":" + _toDisplayString(_ctx.detail?.sewage_rate) + "%", 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_a_tabs, {
          activeKey: _ctx.activeKey,
          "onUpdate:activeKey": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.activeKey) = $event)),
          tabBarGutter: 0
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "1",
              tab: _ctx.t('basicinformation')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 4,
                        class: "title"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("vehiclemodel")) + "：", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 20,
                        class: "info first ellipsis"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail?.vehicle_model), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 4,
                        class: "title"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("vehiclearchitecture")) + "：", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 20,
                        class: "info"
                      }, {
                        default: _withCtx(() => [
                          (
                      _ctx.detail?.os_architecture === _ctx.car_86 ||
                      _ctx.detail?.os_architecture === _ctx.car_64
                    )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "x86_64"))
                            : (
                      _ctx.detail?.os_architecture === _ctx.car_arm ||
                      _ctx.detail?.os_architecture === _ctx.car_arm64
                    )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "ARM64"))
                              : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 4,
                        class: "title"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("vehiclename")) + "：", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 20,
                        class: "info"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.canEdit)
                            ? (_openBlock(), _createBlock(_component_a_input, {
                                key: 0,
                                class: "carName",
                                disabled: _ctx.canEdit,
                                value: _ctx.vehicleName,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vehicleName) = $event))
                              }, null, 8, ["disabled", "value"]))
                            : (_openBlock(), _createBlock(_component_a_input, {
                                key: 1,
                                class: "carName",
                                disabled: _ctx.canEdit,
                                value: _ctx.defaultName,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.defaultName) = $event))
                              }, null, 8, ["disabled", "value"])),
                          _withDirectives(_createVNode(_component_a_button, {
                            type: "primary",
                            size: "small",
                            style: {"margin-left":"20px","background-color":"#4f6bff"},
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.btnRevise()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("modify")), 1)
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.canEdit]
                          ]),
                          _withDirectives(_createVNode(_component_a_button, {
                            type: "primary",
                            size: "small",
                            style: {"margin-left":"20px","background-color":"#4f6bff"},
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveVehicleName()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("save")), 1)
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, !_ctx.canEdit]
                          ]),
                          _withDirectives(_createVNode(_component_a_button, {
                            type: "info",
                            size: "small",
                            style: {"margin-left":"20px"},
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancelVehicleName()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("cancellation")), 1)
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, !_ctx.canEdit]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 4,
                        class: "title"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("registrationtime")) + "：", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 20,
                        class: "info"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail?.register_time), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 4,
                        class: "title"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("simcardiccid")) + ":", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 20,
                        class: "info"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail?.sim_iccid), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 4,
                        class: "title"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("label")) + "：", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 20,
                        class: "info"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.detail?.labels)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail?.labels.split(','), (item, key) => {
                                  return (_openBlock(), _createBlock(_component_a_tag, {
                                    key: key,
                                    color: _ctx.colorList[key]
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 4,
                        class: "title"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("adminpassword")) + "：", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 20,
                        class: "info"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_a_button, {
                            style: {"background-color":"#4f6bff"},
                            type: "primary",
                            size: "small",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.passwordReset('user')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("reset")), 1)
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.canEdit]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 4,
                        class: "title"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("userpassword")) + "：", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 20,
                        class: "info"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_a_button, {
                            style: {"background-color":"#4f6bff"},
                            type: "primary",
                            size: "small",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.passwordReset('operator')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("reset")), 1)
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.canEdit]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["tab"]),
            _createVNode(_component_a_tab_pane, {
              key: "2",
              tab: _ctx.t('versioninformation'),
              "force-render": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, _toDisplayString(_ctx.t("softwareversion")) + "：", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carSoftVersion, (item, key) => {
                      return (_openBlock(), _createElementBlock("li", { key: key }, _toDisplayString(key) + " : " + _toDisplayString(item), 1))
                    }), 128))
                  ]),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, _toDisplayString(_ctx.t("hardwareversion")) + "：", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carHwVersion, (item, key) => {
                      return (_openBlock(), _createElementBlock("li", { key: key }, _toDisplayString(key) + " : " + _toDisplayString(item), 1))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["tab"])
          ]),
          _: 1
        }, 8, ["activeKey"])
      ])
    ])
  ]))
}